import { createSlice, createAsyncThunk, createSelector } from '@reduxjs/toolkit'
import _ from 'lodash'

import client from 'api'

export const fetchActionsMenu = createAsyncThunk('actionsMenu/fetchActionsMenu', async ({ id, url, data }: any, thunkApi: any) => {
    const res = await client.post(url, data, { signal: thunkApi.signal })
    return res.data.data.OUTMENUJSON
},
{
    condition: ({ id, url, data }: any, { getState }) => {
        const { actionsMenu } = getState() as any
        // const { VIEWID: viewId, SELECTEDITEMS: selectedItems } = data

        const currentStatus = actionsMenu.status[id] || 'notloaded'
        const lastParams = actionsMenu.lastParams[id]

        if (currentStatus === 'loading') {
            return false
        }

        if (currentStatus === 'loaded' && _.isEqual(lastParams, data)) {
            return false
        }
    }
})

export const actionsMenuSelector = createSelector(
    [
        (state: any) => state.actionsMenu,
        (_: any, id: string) => id
    ],
    (actionsMenu: any, id: string): any => {
        return {
            status: actionsMenu.status[id] || 'notloaded',
            error: actionsMenu.error[id] || null,
            data: actionsMenu.data[id] || [],
            lastParams: actionsMenu.lastParams[id] || null,
            hasComplexRights: actionsMenu.hasComplexRights[id] || false,
        }
    }
)

const ActionsMenuSlice = createSlice({
    name: 'actionsMenu',
    initialState: {
        status: {},
        error: {},
        data: {},
        lastParams: {},
        hasComplexRights: {}
    } as any,
    reducers: {
        clearActionsMenu: (state, action) => {
            const { id } = action.payload
            state.status[id] = 'notloaded'
            state.error[id] = null
            state.data[id] = null
            state.lastParams[id] = null
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchActionsMenu.pending, (state, action) => {
            const { id, data } = action.meta.arg
            state.status[id] = 'loading'
            state.lastParams[id] = data
            state.error[id] = null
            state.data[id] = null
        })

        builder.addCase(fetchActionsMenu.fulfilled, (state, action) => {
            const { id, data } = action.meta.arg

            state.data[id] = action.payload
            state.hasComplexRights[id] = action.payload ? action.payload.some((a: any) => a.complexRights) : false
            state.error[id] = null
            state.status[id] = 'loaded'
            state.lastParams[id] = data
        })

        builder.addCase(fetchActionsMenu.rejected, (state, action) => {
            const { id } = action.meta.arg

            state.data[id] = null
            state.lastParams[id] = null
            state.error[id] = action.error.message
            state.status[id] = 'error'
        })
    }
})

export const { clearActionsMenu } = ActionsMenuSlice.actions

export default ActionsMenuSlice.reducer
